import { render, staticRenderFns } from "./ExpenseAllowances.vue?vue&type=template&id=c88ba712&scoped=true"
import script from "./ExpenseAllowances.vue?vue&type=script&lang=js"
export * from "./ExpenseAllowances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88ba712",
  null
  
)

export default component.exports